// extracted by mini-css-extract-plugin
export var blue = "_15-h";
export var brand = "_15-d";
export var darkGrey = "_15-g";
export var disabled = "_15-6";
export var disabledSubtle = "_15-7";
export var error = "_15-8";
export var green = "_15-i";
export var grey = "_15-f";
export var icon = "_15-0";
export var inherit = "_15-c";
export var lightGrey = "_15-e";
export var orange = "_15-k";
export var pink = "_15-m";
export var primary = "_15-1";
export var purple = "_15-n";
export var quaternary = "_15-4";
export var quinary = "_15-5";
export var red = "_15-l";
export var secondary = "_15-2";
export var success = "_15-b";
export var tertiary = "_15-3";
export var warning = "_15-9";
export var warningSecondary = "_15-a";
export var white = "_15-o";
export var yellow = "_15-j";